<template>
  <div class="home">
    <div class="main-title">
      <span> <i class="el-icon-folder-opened"></i> 统计 </span>
    </div>
    <div class="statistics-container">
      <div class="statistics-box">
        <p>昨日上报行程</p>
        <p>
          <img src="@/assets/image/icon-lastTrip.png" alt="昨日上报行程" />
          <span>
            {{ yesterdayitineraries | numberFormat }}
          </span>
        </p>
      </div>
      <div class="statistics-box">
        <p>昨日接待人数</p>
        <p style="color: #5c4ac7">
          <img src="@/assets/image/icon-lastPeople.png" alt="昨日接待人数" />
          <span>
            {{ yesterdayreceptionsum | numberFormat }}
          </span>
        </p>
      </div>
      <div class="statistics-box">
        <p>累计上报行程</p>
        <p style="color: #0dab3a">
          <img src="@/assets/image/icon-countTrip.png" alt="累计上报行程" />
          <span>
            {{ totalitineraries | numberFormat }}
          </span>
        </p>
      </div>
      <div class="statistics-box box-r">
        <p>累计接待人数</p>
        <p style="color: #5c4ac7">
          <img src="@/assets/image/icon-countPeople.png" alt="累计接待人数" />
          <span>
            {{ receptionsum | numberFormat }}
          </span>
        </p>
      </div>
    </div>
    <div class="home-main">
      <div class="main-box">
        <div class="main-title">
          <span> <i class="el-icon-folder-opened"></i> 今日行程 </span>
          <!-- <router-link
            :to="{ path: '/ticket-manage', query: { type: 'today' } }"
          >
            <el-button type="text">查看更多</el-button>
          </router-link> -->
        </div>
        <div class="main-table">
          <el-table :data="itinerariestableData" height="350px" border>
            <el-table-column
              type="selection"
              min-width="10"
              align="center"
            ></el-table-column>
            <el-table-column
              label="行程单编号"
              prop="Code"
              min-width="180"
              align="center"
            ></el-table-column>
            <el-table-column
              label="行程名称"
              prop="Name"
              min-width="180"
              align="center"
            ></el-table-column>
            <el-table-column
              label="开始时间"
              prop="StartTime"
              min-width="100"
              align="center"
            >
              <template slot-scope="scope">
                <p>{{ scope.row.StartTime | dateFormat }}</p>
              </template>
            </el-table-column>
            <el-table-column
              label="人数"
              prop="TouristCount"
              min-width="60"
              align="center"
            ></el-table-column>
          </el-table>
        </div>
        <div class="left-pagination">
          <el-pagination
            class="pagination-bottom"
            background
            layout="prev, pager, next, total,sizes"
            :total="itinerariestotal"
            :page-size="itinerariesquery.pageSize"
            :page-sizes="[10, 20, 50]"
            :current-page.sync="itinerariesquery.pageIndex"
            v-on:size-change="handleSizeChange"
            v-on:current-change="handleCurrentPageChange"
          ></el-pagination>
        </div>
      </div>
      <div class="main-box box-r">
        <div class="main-title">
          <span> <i class="el-icon-folder-opened"></i>今日行程占比</span>
        </div>
        <div class="main-chart" id="todayTrip"></div>
      </div>
      <div class="main-box">
        <div class="main-title">
          <span> <i class="el-icon-folder-opened"></i> 新增订单 </span>
          <!-- <router-link :to="{ path: '/order-manage', query: { type: 'add' } }">
            <el-button type="text">查看更多</el-button>
          </router-link> -->
        </div>
        <div class="main-table">
          <el-table :data="ordertableData" height="350px" border>
            <el-table-column
              type="selection"
              min-width="10"
              align="center"
            ></el-table-column>
            <el-table-column
              label="线路名称"
              prop="Name"
              min-width="180"
              align="center"
            ></el-table-column>
            <el-table-column
              label="订单时间"
              prop="OrderTime"
              min-width="100"
              align="center"
            >
              <template slot-scope="scope">
                <p>{{ scope.row.OrderTime | dateFormat }}</p>
              </template>
            </el-table-column>
            <!-- <el-table-column label="购买地点" prop="StoreId" min-width="80" align="center"></el-table-column> -->
            <el-table-column
              label="购买人"
              prop="TouristName"
              min-width="70"
              align="center"
            ></el-table-column>
            <el-table-column
              label="同行人数"
              prop="TotoalCount"
              min-width="90"
              align="center"
            >
            </el-table-column>
          </el-table>
        </div>
        <div class="left-pagination">
          <el-pagination
            class="pagination-bottom"
            background
            layout="prev, pager, next, total,sizes"
            :total="ordertotal"
            :page-size="orderquery.pageSize"
            :page-sizes="[10, 20, 50]"
            :current-page.sync="orderquery.pageIndex"
            v-on:size-change="handleSizeChangeOrder"
            v-on:current-change="handleCurrentPageChangeOrder"
          ></el-pagination>
        </div>
      </div>
      <div class="main-box box-r">
        <div class="main-title">
          <span> <i class="el-icon-folder-opened"></i> 新增订单占比 </span>
        </div>
        <div class="main-chart" id="newOrder"></div>
      </div>
    </div>
  </div>
</template>

<script>
import HOME from "../api/home";
import { mapState } from "vuex";
import {
  numberFormat,
  peopleFormat,
  keyToVal,
  dateFormat,
} from "../filters/filters";
import echarts from "echarts";

export default {
  name: "Home",
  data() {
    return {
      name: [],
      value: [],

      itinerariesquery: {
        PageSize: 10,
        PageIndex: 1,
      },
      itinerariestotal: 0,
      itinerariestableData: [],

      orderquery: {
        PageSize: 10,
        PageIndex: 1,
      },
      ordertotal: 0,
      ordertableData: [],

      totalitineraries: 0,
      yesterdayitineraries: 0,
      receptionsum: 0,
      yesterdayreceptionsum: 0,

      chartOptions: {
        todayOption: {
          // title: {
          //   text: "同名数量统计",
          //   subtext: "纯属虚构",
          //   left: "center",
          // },
          tooltip: {
            trigger: "item",
            formatter: "{b} : {c} ({d}%)",
          },
          legend: {
            type: "plain",
            orient: "horizontal",
            right: 40,
            width: "400",
            top: "40%",
            itemGap: 40,
            icon: "rect",
            itemWidth: 20,
            itemHeight: 20,
            data: [],

            // selected: ['苏州经典一日游线路1','苏州经典一日游线路2','苏州经典一日游线路3','苏州经典一日游线路4'],
          },
          series: [
            {
              name: "旅游线路",
              type: "pie",
              radius: "55%",
              center: ["20%", "50%"],
              data: [],
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
              // labelLine: {
              //   show: false,
              // },
              label: {
                show: false,
                position: "center",
              },
            },
          ],
          color: ["#eda02f", "#dc6235", "#e34a3e" , "#2f515c","#72a6b9","#3d83b0","#2a749f","#3aa986","#96b522","#d9b21b"],
        },

        OrderOption: {
          tooltip: {
            trigger: "item",
            formatter: "{b} : {c} ({d}%)",
          },
          legend: {
            type: "plain",
            orient: "horizontal",
            right: 40,
            width: "400",
            top: "40%",
            itemGap: 40,
            icon: "rect",
            itemWidth: 20,
            itemHeight: 20,
            data: [],

            // selected: ['苏州经典一日游线路1','苏州经典一日游线路2','苏州经典一日游线路3','苏州经典一日游线路4'],
          },
          series: [
            {
              name: "旅游线路",
              type: "pie",
              radius: "55%",
              center: ["20%", "50%"],
              data: [],
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
              // labelLine: {
              //   show: false,
              // },
              label: {
                show: false,
                position: "center",
              },
            },
          ],
          color: ["#eda02f", "#dc6235", "#e34a3e" , "#2f515c","#72a6b9","#3d83b0","#2a749f","#3aa986","#96b522","#d9b21b"],
        },
      },

      screen: {
        width: "",
        height: "",
      },
      charts: {
        todayTrip: null,
        newOrder: null,
      },
    };
  },
  components: {},
  filters: {
    numberFormat,
    dateFormat,
    peopleFormat,
    keyToVal,
  },
  methods: {
    handleSizeChangeOrder(val){
      this.orderquery.PageSize=val;
    },
    handleCurrentPageChangeOrder(val){
      this.orderquery.PageIndex=val;
    },
    loadListOrder() {
      HOME.LoadListOrder(this.orderquery).then((res) => {
        this.ordertotal = res.content.Total;
        this.ordertableData = res.content.OnePageData;
      });
    },

    drawChart() {
      this.charts.todayTrip = echarts.init(
        document.getElementById("todayTrip")
      );
      this.charts.todayTrip.setOption(this.chartOptions.todayOption);
      this.charts.newOrder = echarts.init(document.getElementById("newOrder"));
      this.charts.newOrder.setOption(this.chartOptions.OrderOption);
    },
    resizeChart() {
      this.charts.todayTrip.resize();
      this.charts.newOrder.resize();
    },
    detail() {
      //row,type
    },
    remove() {},

    //分页 页面大小改变
    handleSizeChange(val) {
      this.itinerariesquery.PageSize = val;
    },
    //分页  页码改变
    handleCurrentPageChange(val) {
      this.itinerariesquery.PageIndex = val;
    },
    loadToday() {
      HOME.LoadTodayListItineraries(this.itinerariesquery).then((res) => {
        this.itinerariestotal = res.content.Total;
        this.itinerariestableData = res.content.OnePageData;
      });
    },

    getTodayListItinerariesCount() {
      HOME.GetTodayListItinerariesCount(this.itinerariesdata).then((res) => {
        // this.itinerariesdata = res.content;
        var getData = [];
        for (let i = 0; i < res.content.length; i++) {
          var obj = new Object();
          obj.name = res.content[i].name;
          obj.value = res.content[i].value;
          getData[i] = obj;
        }
        this.charts.todayTrip.setOption({
          legend: {
            data: res.content.name,
          },
          series: [
            {
              data: getData,
            },
          ],
        });
      });
    },

    loadDatas() {
      HOME.LoadDatas(this.datas).then((res) => {
        this.totalitineraries = res.content.totalitineraries;
        this.yesterdayitineraries = res.content.yesterdayitineraries;
        this.receptionsum = res.content.receptionsum;
        this.yesterdayreceptionsum = res.content.yesterdayreceptionsum;
      });
    },

    getListOrderCount() {
      HOME.GetListOrderCount(this.orderdata).then((res) => {
        // this.orderdata = res.content;
        var getData = [];
        for (let i = 0; i < res.content.length; i++) {
          var obj = new Object();
          obj.name = res.content[i].name;
          obj.value = res.content[i].value;
          getData[i] = obj;
        }
        this.charts.newOrder.setOption({
          legend: {
            data: res.content.name,
          },
          series: [
            {
              data: getData,
            },
          ],
        });
      });
    },

  },

  created() {
    this.loadToday();
    this.getTodayListItinerariesCount();
    this.loadDatas();
    this.loadListOrder();
    this.getListOrderCount();
  },
  mounted() {
    let _this = this;
    window.onresize = function () {
      _this.screen.width = document.documentElement.clientWidth;
      _this.screen.height = document.documentElement.clientHeight;
    };
    this.$nextTick(() => {
      this.drawChart();
    });
    this.loadToday();
    this.getTodayListItinerariesCount();
    this.loadDatas();
    this.loadListOrder();
    this.getListOrderCount();
  },
  computed: {
    ...mapState("common", ["ticketStatus", "statusType"]),
  },
  beforeDestroy() {
    window.onresize = null; //取消监听事件
  },
  watch: {
    "screen.width": function () {
      this.resizeChart();
    },
    "screen.height": function () {
      this.resizeChart();
    },
    "itinerariesquery.PageSize": function () {
      this.loadToday();
    },
    "itinerariesquery.PageIndex": function () {
      this.loadToday();
    },
    "orderquery.PageSize": function () {
      this.loadListOrder();
    },
    "orderquery.PageIndex": function () {
      this.loadListOrder();
    },
    datas: function () {
      this.loadDatas();
    },
    orderdata: function () {
      this.getListOrderCount();
    },
    itinerariesdata: function () {
      this.getTodayListItinerariesCount();
    },
  },
};
</script>
<style scoped lang="less">
.home {
  padding-bottom: 20px;
}
.main-title {
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 5px 20px;
  align-items: center;
  background: #efefef;
  height: 35px;
  overflow: hidden;
}
.statistics-container {
  display: flex;
  background: #fff;
}
.statistics-box {
  width: 25%;
  height: 100px;
  padding: 20px;
  border-right: 1px solid #ddd;
}
.statistics-box p:first-of-type {
  font-size: 16px;
  letter-spacing: 1px;
  color: #333333;
}
.statistics-box p:nth-of-type(2) {
  text-align: right;
  font-size: 36px;
  letter-spacing: 3px;
  color: #1976d2;
}
.box-r {
  border-right: none;
}
.home-main {
  display: flex;
  flex-flow: row wrap;
  border-top: 1px solid #ddd;
}
.home-main .main-box {
  width: 50%;
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
}
.main-table {
  height: 350px;
}
.main-pagination {
  height: 50px;
  text-align: right;
}
.main-pagination .pagination-bottom {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
.left-pagination {
  height: 40px;
  background: #dedede;
  text-align: center;
}
.left-pagination .pagination-bottom {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
.main-chart {
  height: 400px;
}
</style>
